/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CheckAccountBalance200,
  CheckAccountBalanceParams,
  CustomerCategoryProductDTO,
  ProductDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAllProducts1 = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/products`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAllProducts1QueryKey = () => {
    return [`/api/products`] as const;
    }

    
export const getGetAllProducts1QueryOptions = <TData = Awaited<ReturnType<typeof getAllProducts1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllProducts1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllProducts1>>> = ({ signal }) => getAllProducts1(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllProducts1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllProducts1QueryResult = NonNullable<Awaited<ReturnType<typeof getAllProducts1>>>
export type GetAllProducts1QueryError = unknown


export function useGetAllProducts1<TData = Awaited<ReturnType<typeof getAllProducts1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProducts1>>,
          TError,
          Awaited<ReturnType<typeof getAllProducts1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProducts1<TData = Awaited<ReturnType<typeof getAllProducts1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProducts1>>,
          TError,
          Awaited<ReturnType<typeof getAllProducts1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProducts1<TData = Awaited<ReturnType<typeof getAllProducts1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllProducts1<TData = Awaited<ReturnType<typeof getAllProducts1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllProducts1QueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getProductsByType1 = (
    productType: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/products/type/${productType}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetProductsByType1QueryKey = (productType?: string,) => {
    return [`/api/products/type/${productType}`] as const;
    }

    
export const getGetProductsByType1QueryOptions = <TData = Awaited<ReturnType<typeof getProductsByType1>>, TError = unknown>(productType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsByType1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsByType1QueryKey(productType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsByType1>>> = ({ signal }) => getProductsByType1(productType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsByType1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductsByType1QueryResult = NonNullable<Awaited<ReturnType<typeof getProductsByType1>>>
export type GetProductsByType1QueryError = unknown


export function useGetProductsByType1<TData = Awaited<ReturnType<typeof getProductsByType1>>, TError = unknown>(
 productType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsByType1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsByType1>>,
          TError,
          Awaited<ReturnType<typeof getProductsByType1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductsByType1<TData = Awaited<ReturnType<typeof getProductsByType1>>, TError = unknown>(
 productType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsByType1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsByType1>>,
          TError,
          Awaited<ReturnType<typeof getProductsByType1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductsByType1<TData = Awaited<ReturnType<typeof getProductsByType1>>, TError = unknown>(
 productType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsByType1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetProductsByType1<TData = Awaited<ReturnType<typeof getProductsByType1>>, TError = unknown>(
 productType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsByType1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductsByType1QueryOptions(productType,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const checkAccountBalance = (
    params: CheckAccountBalanceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CheckAccountBalance200>(
      {url: `/api/products/check-balance`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCheckAccountBalanceQueryKey = (params?: CheckAccountBalanceParams,) => {
    return [`/api/products/check-balance`, ...(params ? [params]: [])] as const;
    }

    
export const getCheckAccountBalanceQueryOptions = <TData = Awaited<ReturnType<typeof checkAccountBalance>>, TError = unknown>(params: CheckAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkAccountBalance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckAccountBalanceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkAccountBalance>>> = ({ signal }) => checkAccountBalance(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkAccountBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CheckAccountBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof checkAccountBalance>>>
export type CheckAccountBalanceQueryError = unknown


export function useCheckAccountBalance<TData = Awaited<ReturnType<typeof checkAccountBalance>>, TError = unknown>(
 params: CheckAccountBalanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkAccountBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkAccountBalance>>,
          TError,
          Awaited<ReturnType<typeof checkAccountBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCheckAccountBalance<TData = Awaited<ReturnType<typeof checkAccountBalance>>, TError = unknown>(
 params: CheckAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkAccountBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkAccountBalance>>,
          TError,
          Awaited<ReturnType<typeof checkAccountBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCheckAccountBalance<TData = Awaited<ReturnType<typeof checkAccountBalance>>, TError = unknown>(
 params: CheckAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkAccountBalance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCheckAccountBalance<TData = Awaited<ReturnType<typeof checkAccountBalance>>, TError = unknown>(
 params: CheckAccountBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkAccountBalance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCheckAccountBalanceQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getProductsForCategory = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryProductDTO[]>(
      {url: `/api/products/category/${categoryId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetProductsForCategoryQueryKey = (categoryId?: number,) => {
    return [`/api/products/category/${categoryId}`] as const;
    }

    
export const getGetProductsForCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getProductsForCategory>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsForCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsForCategoryQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsForCategory>>> = ({ signal }) => getProductsForCategory(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsForCategory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductsForCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsForCategory>>>
export type GetProductsForCategoryQueryError = unknown


export function useGetProductsForCategory<TData = Awaited<ReturnType<typeof getProductsForCategory>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsForCategory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsForCategory>>,
          TError,
          Awaited<ReturnType<typeof getProductsForCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductsForCategory<TData = Awaited<ReturnType<typeof getProductsForCategory>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsForCategory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsForCategory>>,
          TError,
          Awaited<ReturnType<typeof getProductsForCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductsForCategory<TData = Awaited<ReturnType<typeof getProductsForCategory>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsForCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetProductsForCategory<TData = Awaited<ReturnType<typeof getProductsForCategory>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsForCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductsForCategoryQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



